import React from "react";
import { User } from "./Pages/User";
import { HomeContainer } from "./Pages/Home";
// import { LoginPage } from "./Pages/LoginPage";
// import { RegisterPage } from "./Pages/RegisterPage";
// import { PrivateRoute } from "Shoothill.Core/Utils";
import { Route } from "react-router";

export const AppRoutes: React.FC = () => {
	return (
		<>
			<Route exact path="/" component={HomeContainer} />
			{/* <Route exact path="/login" component={LoginPage} />
			<Route exact path="/register" component={RegisterPage} /> */}
			<Route exact path="/iframe" component={User} />
			{/* <PrivateRoute
				exact
				path="/user"
				component={User}
				isAllowed={() => {
					return store.domain.AccountStore.IsLoggedIn && store.domain.AccountStore.isInRole("admin");
				}}
			/> */}
		</>
	);
};
